(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  function initializeGmoAnnouncementMarquees(root = document) {
    root.querySelectorAll('[data-gmo-announcement-marquee]').forEach((marquee) => {
      const source = marquee.querySelector('[data-gmo-marquee-source]');
      const copy = marquee.querySelector('[data-gmo-marquee-copy]');

      if (!source || !copy || copy.childElementCount > 0) return;

      copy.innerHTML = source.innerHTML;
      copy.querySelectorAll('*').forEach((element) => {
        Array.from(element.attributes).forEach((attribute) => {
          if (attribute.name.startsWith('data-shopify')) {
            element.removeAttribute(attribute.name);
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeGmoAnnouncementMarquees());
  } else {
    initializeGmoAnnouncementMarquees();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeGmoAnnouncementMarquees(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
